<h1 mat-dialog-title>{{ data.dialogTitle }}</h1>
<div mat-dialog-content>
  <form class="edit-report-source-dialog-form">
    <mat-form-field>
      <mat-label>Name (required)</mat-label>
      <input matInput
             name="reportSourceName"
             [(ngModel)]="data.reportSource.name" />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Description</mat-label>
      <input matInput
             name="description"
             [(ngModel)]="data.reportSource.description" />
    </mat-form-field>
    <br />
    <ng-container>
      <mat-checkbox name="data.reportSource.preFilterCompanyAvailable" [(ngModel)]="data.reportSource.preFilterCompanyAvailable">PreFilter -- Allow Company Filtering</mat-checkbox>
    </ng-container>
    <br />
    <ng-container>
      <mat-checkbox name="data.reportSource.preFilterTitleAvailable" [(ngModel)]="data.reportSource.preFilterTitleAvailable">PreFilter -- Allow Title Filtering</mat-checkbox>
    </ng-container>
    <br />
    <ng-container>
      <mat-checkbox name="data.reportSource.preFilterRegionAvailable" [(ngModel)]="data.reportSource.preFilterRegionAvailable">PreFilter -- Allow Region Filtering</mat-checkbox>
    </ng-container>
    <br />
    <ng-container>
      <mat-checkbox name="data.reportSource.preFilterIndustryAvailable" [(ngModel)]="data.reportSource.preFilterIndustryAvailable">PreFilter -- Allow Industry Filtering</mat-checkbox>
    </ng-container>
    <br />
    <ng-container>
      <mat-checkbox name="data.reportSource.preFilterOccupationAvailable" [(ngModel)]="data.reportSource.preFilterOccupationAvailable">PreFilter -- Allow Occupation Filtering</mat-checkbox>
    </ng-container>
    <br />
    <ng-container>
      <mat-checkbox name="data.reportSource.active" [(ngModel)]="data.reportSource.active">Active</mat-checkbox>
    </ng-container>
    <br />
    <ng-container>
      <mat-label>Report PBIX File: ({{ data.reportSource.fileName }})</mat-label>
      <input type="file"
             id="inputFile"
             (change)="handleFileInput($event.target.files)" />
    </ng-container>
    <ng-container *ngIf="uploadingReportSource">
      <b>Uploading Report, Please Wait....</b>
    </ng-container>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-raised-button
          color="primary"
          (click)="onConfirmClick()"
          cdkFocusInitial>
    Confirm
  </button>
  <button mat-raised-button (click)="onCancelClick()">Cancel</button>
</div>

